export function emitTelemetry(handler, kind, message, extra) {
    if (typeof handler !== "function")
        return;
    try {
        handler({
            kind,
            message,
            code: extra?.code,
            context: extra?.context,
            timestamp: Date.now(),
        });
    }
    catch {
        /* telemetry must never break the chart */
    }
}
